import ko from "knockout";
import metaCache from "flow/utils/metaCache";

ko.validation.rules["oneMustBePicked"] = {
    validator: function (value: any[]) {
        if (value === undefined || value === null) return false;
        return String(value).length > 0;
    },
    message: () => metaCache.translate("FlowHtml.Translations.OneMustBePicked")
};

ko.validation.registerExtenders();
